import script from "./KStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./KStatus.vue?vue&type=script&setup=true&lang=ts"

import "./KStatus.vue?vue&type=style&index=0&id=e4a3fdc0&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4a3fdc0"]])

export default __exports__